import { KHCN_LOGO } from "constants/images";

const SidebarLogo = () => {
  return (
    <div className="app-dashboard-sidebar-logo">
      <div className="flex items-center">
        <img alt="" src={KHCN_LOGO} width={40} height={40} />
        <h1 className="text-xs text-dark font-black ml-[8px]">
          SỞ KHOA HỌC VÀ CÔNG NGHỆ
          <br />
          THÀNH PHỐ HỒ CHÍ MINH
        </h1>
      </div>
      <h1 className="text-sm text-primary font-black mt-2">
        XÁC THỰC CHỨNG NHẬN <br /> ỨNG DỤNG CÔNG NGHỆ BLOCKCHAIN
      </h1>
    </div>
  );
};

export default SidebarLogo;
